export default function Footer() {
    return (
        <div className="pt-66px-1199">
            <div className="styles_wrapperFooter__mW_BR MuiBox-root css-0 hidden-1199">
                <div className="styles_footer__tu4oJ MuiBox-root css-0">
                    {/* TOP */}
                    <div>
                        <div className="styles_topContent__KNn9X">
                            <a href="/">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: 108,
                                        height: 108,
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        src="/images/logothuoc.png"
                                        alt="Buymed"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            margin: "auto",
                                            display: "block",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>
                            </a>

                            {/* <a className="styles_titleIntroduce__w1GuK" href="/home">
                                <span className="styles_thuocsi__lQYr1">
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        thuocsi.vn
                                    </p>
                                </span>
                                &nbsp;
                                <p className="MuiTypography-root styles_thuocsidefinition__gonlJ MuiTypography-body1">
                                    Là website thuộc sở hữu của công ty TNHH Buymed.
                                </p>
                            </a> */}
                        </div>

                        {/* BODY */}
                        <div className="styles_bodyContent__SmDLg pb-4">
                            <div className="MuiGrid-root styles_boxInfoLeft__4puLf MuiGrid-item">
                                <div>
                                    <p className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1">
                                        CÔNG TY TNHH DƯỢC PHẨM TÂM HẠNH
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Mã số thuế:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>0314758651</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Địa Chỉ:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>80 Đường số 08, Khu Phố 02, Phường An Lạc, Quận Bình Tân, Thành phố Hồ Chí Minh</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Đại diện pháp luật:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>Trương Thành Tâm</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Ngày cấp giấy phép:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>22/07/2016</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Ngày hoạt động:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>09/08/2016 (Đã hoạt động 9 năm)</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Điện thoại trụ sở:</strong>
                                        <span style={{ fontWeight: 400, fontFamily: "googlesansregular", marginLeft: 5 }}>0912345678</span>
                                    </p>

                                    <p className="MuiTypography-root styles_bodyItemTT__Y3iW_ MuiTypography-body1" style={{ marginTop: 10 }}>
                                        <strong style={{ fontWeight: 500 }}>Trạng thái:</strong>
                                        <span style={{ fontWeight: 600, fontFamily: "googlesansregular", marginLeft: 5, color: "green" }}>Đang hoạt động</span>
                                    </p>
                                </div>

                                {/* CONTACT */}
                                <div className="styles_contact__IBdme">
                                    <p className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1">
                                        Liên hệ
                                    </p>

                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 MuiGrid-align-items-xs-center" style={{ marginTop: 10 }}>
                                        <div className="MuiGrid-root MuiGrid-item">
                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/images/footer-v2/Contact/support.svg"
                                                alt="support"
                                                width={18}
                                                height={18}
                                            />
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true">
                                            <span className="styles_contactBody__y7ouD">
                                                <a href="mailto:hotro@buymed.com">hotro@duocphamtamhanh.com</a>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 MuiGrid-align-items-xs-center" style={{ marginTop: 8 }}>
                                        <div className="MuiGrid-root MuiGrid-item">
                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/images/footer-v2/Contact/call.svg"
                                                alt="call"
                                                width={18}
                                                height={18}
                                            />
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true">
                                            <span className="styles_contactBody__y7ouD">
                                                Tổng đài miễn phí:&nbsp;
                                                <a href="tel:18002038">1800 2038</a>
                                                <span className="styles_callTime__bRNJ7">
                                                    &nbsp;(T2 - CN: 8h-20h)
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* LICENSE */}
                                <div className="styles_license__R1r4m MuiBox-root css-0">
                                    <div className="styles_absoluteItem__rZF7n items-center">
                                        <a href="http://online.gov.vn/Home/WebDetails/52192">
                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/images/footer/logo_register.png"
                                                alt="gov"
                                                width={120}
                                                height={47}
                                            />
                                        </a>
                                        <a href="https://cystack.net/projects/buymed">
                                            <img
                                                src="https://s.cystack.net/resource/cystack/badge_blue.svg"
                                                alt="cystack"
                                                width={120}
                                                height={47}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="MuiGrid-root">
                                <div className="styles_centerContainer__WQYcX">
                                    {/* ===== Thông tin chung ===== */}
                                    <div>
                                        <p className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1">
                                            Thông tin chung
                                        </p>

                                        <div
                                            className="MuiGrid-root MuiGrid-container"
                                            style={{ marginTop: 8 }}
                                        >
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-lg-12">
                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/about-us"
                                                >
                                                    <p
                                                        className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1"
                                                        style={{ textTransform: "none" }}
                                                    >
                                                        Thông Tin Về Buymed
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/static/quy-che-hoat-dong/quy-che-hoat-dong.pdf"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Quy chế hoạt động
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_alink__q8NSf"
                                                    href="/terms-and-condition"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Điều khoản sử dụng
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/chinh-sach-bao-mat"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách bảo mật
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/chinh-sach-bao-mat-thanh-toan"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách bảo mật thanh toán
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/chinh-sach-giai-quyet-khieu-nai"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách giải quyết khiếu nại
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/chinh-sach-dang-tai-san-pham"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách đăng tải sản phẩm
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/chinh-sach-doi-tra"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách đổi trả
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/shipping-policy"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Chính sách vận chuyển
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ===== Hỗ trợ người sử dụng ===== */}
                                    <div>
                                        <p className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1">
                                            Hỗ trợ người sử dụng
                                        </p>

                                        <div
                                            className="MuiGrid-root MuiGrid-container"
                                            style={{ marginTop: 8 }}
                                        >
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-lg-12">
                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="https://hotro.thuocsi.vn/"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Câu hỏi thường gặp
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/huong-dan-dang-tai-san-pham"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Hướng dẫn đăng tải sản phẩm
                                                    </p>
                                                </a>

                                                <a
                                                    className="styles_mobile_rootBase__8z7PQ styles_linkComp__uol2R"
                                                    href="/huong-dan-dat-hang-va-thanh-toan"
                                                >
                                                    <p className="MuiTypography-root styles_link__Nw0pc MuiTypography-body1">
                                                        Hướng dẫn đặt hàng và thanh toán
                                                    </p>
                                                </a>
                                            </div>
                                        </div>

                                        {/* ===== Dịch vụ giao hàng ===== */}
                                        <div className="styles_marginLeft__aY3e6">
                                            <div className="MuiGrid-root">
                                                <p
                                                    className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1"
                                                    style={{ marginTop: 25 }}
                                                >
                                                    Dịch vụ giao hàng
                                                </p>

                                                <div
                                                    className="MuiGrid-root"
                                                    style={{ marginTop: 10, flexWrap: "nowrap" }}
                                                >
                                                    <div className="styles_TitleService__z3fV0 MuiBox-root css-0">
                                                        {[
                                                            {
                                                                src: "https://cdn-web-next.thuocsi.vn/images/footer-v2/ShipService/ghtk.png",
                                                                width: 82,
                                                                height: 25,
                                                                alt: "GHTK",
                                                            },
                                                            {
                                                                src: "https://cdn-web-next.thuocsi.vn/images/footer-v2/ShipService/KTL_logo.jpg",
                                                                width: 64,
                                                                height: 24,
                                                                alt: "KERRY",
                                                            },
                                                            {
                                                                src: "https://cdn-web-next.thuocsi.vn/images/footer-v2/ShipService/Viettel_Post_logo.jpg",
                                                                width: 62,
                                                                height: 24,
                                                                alt: "VIETTELPOST",
                                                            },
                                                        ].map((item) => (
                                                            <div
                                                                key={item.src}
                                                                className="styles_serviceIcon__3vvHs MuiBox-root css-0"
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: item.width,
                                                                        height: item.height,
                                                                        position: "relative",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={item.src}
                                                                        alt={item.alt}
                                                                        className="styles_border__L4bAA"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%",
                                                                        }}
                                                                    />
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ===== Kết nối ===== */}
                                            <div className="MuiGrid-root">
                                                <p className="MuiTypography-root styles_titleItem__pnlg_ MuiTypography-body1">
                                                    Kết Nối Với Chúng Tôi
                                                </p>

                                                <div className="styles_TitleConnect__u67HM MuiBox-root css-0">
                                                    {[
                                                        ["facebook", "https://www.facebook.com/buymedvn"],
                                                        ["zalo", "https://zalo.me/1836616064223034882"],
                                                        ["linked", "https://www.linkedin.com/company/buymedcoltd"],
                                                        ["tiktok", "https://www.tiktok.com/@buymed.com"],
                                                    ].map(([name, link]) => (
                                                        <div
                                                            key={name}
                                                            className="styles_connectIcon__0lMV3 MuiBox-root css-0"
                                                        >
                                                            <a href={link} target="_blank" rel="noreferrer">
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: 20,
                                                                        height: 20,
                                                                        position: "relative",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={`https://cdn-web-next.thuocsi.vn/images/footer-v2/Connect/${name}_icon.svg`}
                                                                        alt={`${name}-connect`}
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%",
                                                                        }}
                                                                    />
                                                                </span>
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                {/* Title */}
                                <div className="MuiBox-root css-0">
                                    <p className="MuiTypography-root styles_taiAppTai__u7Mzm MuiTypography-body1">
                                        Tải xuống ứng dụng <span>Buymed</span>
                                    </p>
                                </div>

                                {/* Download + Phone */}
                                <div className="MuiBox-root css-0">
                                    {/* Download buttons */}
                                    <div className="styles_linkDownload__ZSNMb">
                                        <a
                                            className="styles_mobile_rootBase__8z7PQ"
                                            target="_blank"
                                            rel="noreferrer"
                                            href="https://apps.apple.com/vn/app/thuocsi/id1518730923"
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "inline-block",
                                                    overflow: "hidden",
                                                    width: 107,
                                                    height: 32,
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "relative",
                                                }}
                                            >
                                                <img
                                                    alt="Tải xuống ứng dụng thuocsi.vn tại App Store"
                                                    src="https://cdn-web-next.thuocsi.vn/images/footer-v2/Download/appstore_v2.png"
                                                    decoding="async"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                    }}
                                                />
                                            </span>
                                        </a>

                                        <a
                                            className="styles_mobile_rootBase__8z7PQ"
                                            target="_blank"
                                            rel="noreferrer"
                                            href="https://play.google.com/store/apps/details?id=com.buymed.app&hl=en_US"
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "inline-block",
                                                    overflow: "hidden",
                                                    width: 107,
                                                    height: 32,
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "relative",
                                                }}
                                            >
                                                <img
                                                    alt="Tải xuống ứng dụng thuocsi.vn tại Google Play"
                                                    src="https://cdn-web-next.thuocsi.vn/images/footer-v2/Download/googleplay_v2.png"
                                                    decoding="async"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                    }}
                                                />
                                            </span>
                                        </a>
                                    </div>

                                    {/* Phone mockup */}
                                    <div className="styles_phoneScreen__6w8jN">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: 150,
                                                height: 304,
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                            }}
                                        >
                                            <img
                                                alt="phone frame"
                                                src="https://cdn-web-next.thuocsi.vn/images/home/footer-phone-new.png"
                                                decoding="async"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                }}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER BOTTOM */}
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12" style={{ width: "100%" }}>
                        <hr className="MuiDivider-root" />
                        <div className="styles_textCenter__Rp8Og text-center w-full">
                            <p className="MuiTypography-root styles_endOfFooter__zhBzr MuiTypography-body1">
                                © Bản quyền thuộc Công Ty TNHH Buymed - 2025
                            </p>
                        </div>
                        <hr className="MuiDivider-root" style={{ marginTop: 40, backgroundColor: "white" }} />
                    </div>
                </div>
            </div>

            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__ZzET1 mui-fixed MuiPaper-elevation4 show-1199">
                <footer className="styles_wrapperToolBar__PKKaq">
                    <div className="MuiToolbar-root MuiToolbar-regular styles_footerToolbar__bC99q MuiToolbar-gutters">

                        {/* Trang Chủ */}
                        <div className="styles_icon__IVugL">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root styles_iconWrapper__Vh1pH MuiIconButton-colorInherit MuiIconButton-edgeStart"
                                tabIndex={0}
                                type="button"
                            >
                                <span className="MuiIconButton-label">
                                    <span className="img-wrapper">
                                        <img
                                            alt="Trang Chủ"
                                            src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024d23047f5bab7130a1ad1249fe129home.svg?quality=100"
                                        />
                                    </span>
                                    <span className="styles_text__Ejg1N">Trang Chủ</span>
                                </span>
                                <span className="MuiTouchRipple-root" />
                            </button>
                        </div>

                        {/* Khuyến Mãi */}
                        <div className="styles_icon__IVugL">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root styles_iconWrapper__Vh1pH MuiIconButton-colorInherit MuiIconButton-edgeStart"
                                tabIndex={0}
                                type="button"
                            >
                                <span className="MuiIconButton-label">
                                    <span className="img-wrapper">
                                        <img
                                            alt="Khuyến Mãi"
                                            src="https://gcs.buymed.com/thuocsi-live/internal/cms/202456107a5fd152e202af94f8ec2d4ekm.svg?quality=100"
                                        />
                                    </span>
                                    <span className="styles_text__Ejg1N">Khuyến Mãi</span>
                                </span>
                                <span className="MuiTouchRipple-root" />
                            </button>
                        </div>

                        {/* Đặt Nhanh (special) */}
                        <div className="styles_icon_special__g3v7n">
                            <div className="styles_wrapperButtonQuickOrder__z3ed3">
                                <div className="styles_qOrderIcon__tLauJ">
                                    <div className="styles_fabButton__bN9HS">
                                        <img
                                            alt="Đặt Nhanh"
                                            src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024b48795768e5e0048f9581a2933a5Frame_1000004549.svg?quality=100"
                                        />
                                    </div>
                                    <span className="styles_textQuickOrder__JxRZF">
                                        Đặt Nhanh
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Đơn Hàng */}
                        <div className="styles_icon__IVugL">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root styles_iconWrapper__Vh1pH MuiIconButton-colorInherit MuiIconButton-edgeStart"
                                tabIndex={0}
                                type="button"
                            >
                                <span className="MuiIconButton-label">
                                    <span className="img-wrapper">
                                        <img
                                            alt="Đơn Hàng"
                                            src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024233df452776103750649bcc700deorder.svg?quality=100"
                                        />
                                    </span>
                                    <span className="styles_text__Ejg1N">Đơn Hàng</span>
                                </span>
                                <span className="MuiTouchRipple-root" />
                            </button>
                        </div>

                        {/* Lợi Nhuận Cao */}
                        <div className="styles_icon__IVugL">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root styles_iconWrapper__Vh1pH MuiIconButton-colorInherit MuiIconButton-edgeStart"
                                tabIndex={0}
                                type="button"
                            >
                                <span className="MuiIconButton-label">
                                    <span className="img-wrapper">
                                        <img
                                            className="w-[24px] h-[24px]"
                                            alt="Lợi Nhuận Cao"
                                            src="https://gcs.buymed.com/thuocsi-live/internal/cms/20246cb7be8038bf1ea16f7117f68bf3fire.svg?quality=100"
                                        />
                                    </span>
                                    <span className="styles_text__Ejg1N">Lợi Nhuận Cao</span>
                                </span>
                                <span className="MuiTouchRipple-root" />
                            </button>
                        </div>

                    </div>
                </footer>
            </header>
        </div>
    );
}
